function displayUserSidebar(idElement){
    $("#" + idElement).removeClass('hidden');
    $("#" + idElement + ':not(.hidden)')[0].showModal();
}

$(document).ready(function () {
	var guessscoreSuccess = false;

	function resetGuessscoreSignupModal() {
		if (!guessscoreSuccess) {
			return;
		}

		var signupModal = $('#worldcup_game_signup');
		signupModal.find('.modal-subtitle').remove();
		var signupForm = signupModal.find('form').first();
		signupForm.css('display', 'block');
		if (signupForm.length) {
			signupForm[0].reset();
		}
		guessscoreSuccess = false;
	}

	var signupDialog = document.getElementById('worldcup_game_signup');
	if (signupDialog) {
		signupDialog.addEventListener('close', function () {
			resetGuessscoreSignupModal();
		});
	}

    //show and hide vote percentage in voted or finished match
	$('body').on('click', function(e){
		if ($('.show-vote-wrapper').is(":visible")) {
            $('.show-vote-wrapper').hide();
        }
	});

    $('body').on('click', '.show_more_info_vote', function (e) {
		e.stopImmediatePropagation();
		e.preventDefault();
        
		if ($(this).parent().children('.show-vote-wrapper').is(":visible")) {
            $(this).parent().children('.show-vote-wrapper').hide();
        } else {
            $(this).parent().children('.show-vote-wrapper').show();
        }		
    });
	
    $("body").on("click", ".js_dropdown_tab", function () {
        console.log("dropdown clicked");
        if ($(this).parent().children(".js_dropdown_info").is(":visible")) {
            console.log("dropdown clicked hide");
            $(".js_dropdown_links_content").hide();
            $(".js_dropdown_info").hide();
        } else {
            console.log("dropdown clicked open");
            $(".js_dropdown_links_content").hide();
            $(".js_dropdown_info").hide();
            $(this).parent().children(".js_dropdown_info").show();
        }
    });

    $("body").on("click", ".js_dropdown_info li", function () {
        if ($(this).parent().parent().hasClass("dropdown_image_data")) {
            clickedLi = $(this);
            b(clickedLi);
        } else {
            $(this).parent().parent().children(".drop_down_tab").children(".drop_down_text").text($(this).text());
            $(this).parent().children("li").removeClass("last_clicked");
            $(this).addClass("last_clicked");
            $(this).parent(".js_dropdown_info").hide();
        }
    });

	$("body").on("click",".send_prediction_first",function()
	{displayUserSidebar("worldcup_game_signup")});

	//navigation drop-down
$('body').on('click', '.drop-trgr', function (e) {
	e.preventDefault();
	e.stopImmediatePropagation();
	$('.drop-menu.open, .drop-menu-mb.open').not('#' + $(this).attr('data-id')).removeClass('open');
	$('.drop-trgr.opn').not(this).removeClass('opn');
	$('#' + $(this).attr('data-id')).toggleClass('open');
	$(this).toggleClass('opn');
});

//form drop select
$('body').on('click', '#worldcup_game_signup .drop-menu > li', function (e) {
		
		e.preventDefault();
		e.stopImmediatePropagation();
		$('.drop-selected[data-id=' + $(this).parents('.drop-menu').attr('id') + '] span').html($(this).text());
		$(this).parents('.drop-menu.open').removeClass('open');
		$('.drop-trgr.opn[data-id=' + $(this).parents('.drop-menu').attr('id') + ']').removeClass('opn');
		
		
		if(typeof($(this).data('href')) !== 'undefined'){
		    var url = $(this).data('href');
		    $.ajax({
                        url: url,
                        dataType: 'text',
                        type: 'POST',
                        beforeSend: function () {
                            // parent.addClass('loading-ajx');
                        },
                        success: function (response) {
                            $('#olympic').html(response);
                        }
                    });
		}		
		
	});
	
	
$('body').on('click', '.drop-menu a[href="#"], .drop-menu a:not([href])', function (e) {
	e.preventDefault();
	e.stopPropagation();
});

$('body').on('click', '.drop-menu a[href!="#"]', function (e) {
	e.stopPropagation();	
});

$('body').on('click', 'a[href="#"]', function (e) {
	e.preventDefault();
	e.stopPropagation();	
});

    function b(d) {
        d.parent().parent().children(".drop_down_tab").children(".drop_down_text").html(d.children("span").clone());
        d.parent().children("li").removeClass("last_clicked");
        d.addClass("last_clicked");
        d.parent(".js_dropdown_info").hide();
    }

    $("body").on("click", ".drop_down_change_info", function (d) {
        d.stopPropagation();
    });
	
	function validateEmail(email) {
        var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return reg.test(email);
    }
	
	function validatePhoneBG(phoneVal){
		var phoneNumber = phoneVal.trim();
		var regex = /^[\+|\d]{9,13}$/g;
		return regex.test(phoneNumber);
	}
	
	function gameOurGame(email, name, surname, phone, answer, questionId, years, terms) {
        $.ajax({
            type: "POST",
			url: '/bg-football/games/save_user_vote_our_game',
            crossDomain: true,
            dataType: "json",
            data: {
                userEmail: email,
                userName: name,
				userSurname: surname,
                userYears: years,
                userTerms: terms,
                userPhone: phone,
                userAnswer: answer,
				questionId: questionId,
				gameDomainName: 'game_ourgame'
            },
            success: function (response) {
                var data = response;
                if (data['success'] == 1) {
                    $('#not_worldcup_our_game').addClass('g-hidden-right-slide');
                    $('.profile-overlay').css('display', 'none');
                    $('body').css('overflow', 'auto');					
					var url = '/bg-football/nashata-igra';
					var form = $('<form action="' + url + '" method="post">' +
					  '<input type="hidden" name="user_vote_message" value="Успешно се регистрирахте за играта!" />' +
					  '</form>');
					$('body').append(form);
					form.submit();					
                } else {
                    $('#not_worldcup_our_game .error-field-noprediction').text(data['msg']);
                    $('#not_worldcup_our_game .error-field-noprediction').removeClass('g-hidden');
                }
            }
        });
    }

    //ajax for sending infor for voted user
    function gamePrediction(email, name, data, years, terms, phone, surname, city, game_type, game_domain, gdg_moduleId, gdg_voteVideoId) {
		
//        console.log("I send");
//        console.log(data);		
		if(game_type == 'goaloftheday' || game_type == 'guessscore'){		
			$.ajax({
				type: "POST",
				url: '/worldcup2026/game/save_user_vote_' + game_type,
				crossDomain: true,
				dataType: "json",
				data: {
					userEmail: email,
					userName: name,
					userSurname: surname,
					userCity: city,
					userYears: years,
					userTerms: terms,
					userPhone: phone,
					gameDomainName: game_domain,
					data: data,
					moduleId: gdg_moduleId,
					voteVideoId: gdg_voteVideoId
				},
				success: function (response) {
					var data = response;
	                
					if (data['success'] == 1) {
						if(game_type == 'guessscore') {
							showVoteWorldCup();
							var signupModal = $('#worldcup_game_signup');
							signupModal.find('.modal-subtitle').remove();
							var subtitle = $('<h3 class="modal-subtitle">Успешна регистрация</h3>');
							signupModal.find('.modal-title').after(subtitle);
							signupModal.find('form').css('display', 'none');
							guessscoreSuccess = true;
						} else if(game_type == 'goaloftheday') {
							$('#worldcup_game_signup, #worldcup_goal_ofday').addClass('g-hidden-right-slide');
							$('.profile-overlay').css('display', 'none');
							$('body').css('overflow', 'auto');
							var voteVideoId = gdg_voteVideoId;
							var moduleId = gdg_moduleId;
							var url = '/gol-na-kruga/votenoreg-' + moduleId + '-' + voteVideoId;
							$.ajax({
								url: url,
								method: 'POST',
								success: function (data) {
									var resultObject = JSON.parse(data);
									if (typeof resultObject.votes !== 'undefined' &&
										typeof resultObject.moduleId !== 'undefined' &&
										resultObject.votes !== false) {
										updateGoalModuleResultsNoreg(resultObject.moduleId, resultObject.votes)
									}
								}
							});
						}
					} else {
						if(game_type == 'guessscore') {
							$('#worldcup_game_signup .error-field-noprediction').text(data['msg']);
							$('#worldcup_game_signup .error-field-noprediction').removeClass('g-hidden');
						} else if(game_type == 'goaloftheday') {
							$('#worldcup_goal_ofday .error-field-noprediction').text(data['msg']);
							$('#worldcup_goal_ofday .error-field-noprediction').removeClass('g-hidden');
						}
						if(game_type == 'guessscore') {
							//showVoteWorldCup();
						}
					}
				}
			});
		}		
    }
	
	//ajax operation for vizualization result goal of day
	function updateGoalModuleResultsNoreg(moduleId, votesPercent) {
        var moduleWrapperId = 'goal-module-' + moduleId;
        var elements = $('#' + moduleWrapperId + ' > div');
        var tempWrapper = null;
        for (var i = 0; i < 3; i++) {
            tempWrapper = $(elements[i]).find('.interaction-wrapper');
            tempWrapper.find('button').addClass("g-hidden");
            tempWrapper.find('.g-widget-results .results span').text(votesPercent[i] + ' %');
            tempWrapper.find('.g-widget-results').removeClass('g-hidden');
        }
    }
	
    //ajax to get percentage in voted or finished match
    function ajaxForPercent(matchID) {
        $.ajax({
            type: "POST",
            url: '/worldcup2026/game/results/' + matchID,
            crossDomain: true,
            dataType: "json",
            success: function (response) {
                var data = response;
//                console.log(data);
                if (data['success'] == 1) {
                    var selectedMatch = $('div[data-match-id="' + matchID + '"]');
                    selectedMatch.find('.home_percent').text(data.results.percents['home'] + '%');
                    selectedMatch.find('.away_percent').text(data.results.percents['away'] + '%');
                    selectedMatch.find('.equal_percent').text(data.results.percents['equal'] + '%');
                }
            }
        });
    }
    //show voted matches percentage and voted numbers
    function showVoteWorldCup() {
//        console.log("showVoteWorldCup");
        if (getCookie('worldcup2026game_guessscore')) {
            var cookieWC2018g = jQuery.parseJSON(getCookie('worldcup2026game_guessscore')),
                    nubmerVotedMatches = 0,
                    nubmerVisibleMatches = 0;
//            console.log(cookieWC2018g);
            $('.table-display').each(function (index) {
                var matchID = $(this).data('match-id');
                nubmerVisibleMatches++;
                if (cookieWC2018g[matchID] || $(this).hasClass("match-voted") || $(this).hasClass("cant-vote")) {
                    if (cookieWC2018g[matchID]) {
                        $(this).addClass('match-voted');
                        $(this).find('.prediction-team1 > span').text(cookieWC2018g[$(this).data('match-id')].home);
                        $(this).find('.prediction-team2 > span').text(cookieWC2018g[$(this).data('match-id')].away);
                        $(this).find('.js_dropdown_info').remove();
                        ajaxForPercent(matchID);
                    } else if ($(this).hasClass("match-voted")) {
                        $(this).addClass('match-voted');
                        $(this).find('.prediction-team1 > span').text(cookieWC2018g[$(this).data('match-id')].home);
                        $(this).find('.prediction-team2 > span').text(cookieWC2018g[$(this).data('match-id')].away);
                        ajaxForPercent(matchID);
                    }
                    nubmerVotedMatches++;
                }
            });
            if (nubmerVotedMatches === nubmerVisibleMatches) {
                $('.prediction-gong-game .btn-wrapper-world-game').remove();
            }
        }
        $('.prediction-gong-game .loader-matches').css('visibility', 'hidden');
        $('.prediction-gong-game .livescore-widgets').css('visibility', 'visible');		
    }
    ;
    //click function
    $('#worldcup_game_signup input').on('click touch', function () {
        $(this).parent().children(".validation-error").addClass("g-hidden");
        $(this).removeClass("error-field");
    });
    $('#worldcup_game_signup input').on('click touch', function () {
        $(this).parent().children(".validation-error").addClass("g-hidden");
        $(this).removeClass("error-field");
    });

    $('#worldcup_game_signup input[type="checkbox"]').change(function () {
        $(this).parent().parent().children('.validation-error').addClass('g-hidden');
    });
	
	$('body').on('click', '.close-x-forms', function (e) {
		$(".side-menu").addClass("g-hidden");
		$(".menu-vissble-on-page-load").removeClass("current-side-menu");
		$(".menu-vissble-on-page-load").css("transition", "all 0.5s ease"); 
		$(".prev-side-menu").removeClass("prev-side-menu");
		$(".current-side-menu").removeClass("current-side-menu");
		$(".overlay").css("display", "none");
		$("body").css("overflow", "auto");
		$(".profile-side-menu").each(function (g) {
			if ($(this).is("#main-profile-menu") || $(this).is("#information_for_author") || $(this).is("#worldcup_game_signup")) {
				$(this).addClass("g-hidden-right-slide");
			} else {
				$(this).addClass("g-hidden");
			}
		});
		$(".profile-overlay").css("display", "none");
		$("body").css("overflow", "auto");
		resetGuessscoreSignupModal();
	});

	$('body').on('click', '#game_submit_ourgame', function (e) {		
        e.preventDefault();
        var flag = true,
				gameAnswer = $('#game-answer'),
                gameEmail = $('#game-email'),
                gameName = $('#game-name'),
				gameSurname = $('#game-surname'),
                gamePhone = $('#game-phone'),
				gameQuestionId = $('#question_id_ourgame'),
                yearsCheck = $('#game-years-checkbox'),
                termsCheck = $('#game-terms-checkbox');
				
				
		gameEmail.removeClass('error-field');
        gameEmail.next().addClass('g-hidden');		
		gameName.removeClass('error-field');
        gameName.next().addClass('g-hidden');		
		gameSurname.removeClass('error-field');
        gameSurname.next().addClass('g-hidden');		
		gamePhone.removeClass('error-field');
        gamePhone.next().addClass('g-hidden');		
		gameAnswer.removeClass('error-field');
        gameAnswer.next().addClass('g-hidden');		
		yearsCheck.parent().parent().children('.validation-error').addClass('g-hidden');
		termsCheck.parent().parent().children('.validation-error').addClass('g-hidden');
				
		
		if (gameEmail.val().length === 0) {
            gameEmail.addClass('error-field');
            gameEmail.next().removeClass('g-hidden');
            flag = false;
        }
		
		if(flag == true){
			if (!validateEmail(gameEmail.val())) {
				gameEmail.addClass('error-field');
				gameEmail.next().removeClass('g-hidden');
				flag = false;
			}
		}
		
        if (gameName.val().length === 0) {
            gameName.addClass('error-field');
            gameName.parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
		 if (gameSurname.val().length === 0) {
            gameSurname.addClass('error-field');
            gameSurname.parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
        if (gamePhone.val().length === 0) {
            gamePhone.addClass('error-field');
            gamePhone.parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
		if(flag == true){
			if (!validatePhoneBG(gamePhone.val())) {
				gamePhone.addClass('error-field');
				gamePhone.next().removeClass('g-hidden');
				flag = false;
			}
		}	
		
		if (gameQuestionId.val().length === 0) {
            flag = false;
        }
		if (gameAnswer.val().length === 0) {
            gameAnswer.addClass('error-field');
            gameAnswer.parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
        if (!(yearsCheck.is(':checked'))) {
            yearsCheck.parent().parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
        if (!(termsCheck.is(':checked'))) {
            termsCheck.parent().parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
		if (flag) {
            $('#not_worldcup_our_game .error-field-noprediction').addClass('g-hidden');
            var email = gameEmail.val(),
                    name = gameName.val(),
					surname = gameSurname.val(),
					phone = gamePhone.val(),
					answer = gameAnswer.val(),
					questionId = gameQuestionId.val(),
                    years = yearsCheck.is(':checked'),                    
                    terms = termsCheck.is(':checked');
            gameOurGame(email, name, surname, phone, answer, questionId, years, terms);
        }		
	 });

    //check form and studying information for ajax send
    $('body').on('click', '#game_submit_info', function (e) {
        e.preventDefault();
        var flag = true,
                gameEmail = $('#game-email'),
                gameName = $('#game-name'),
				gameSurname = $('#game-surname'),
				gameCity = $('#game-city'),
                gamePhone = $('#game-phone'),
                yearsCheck = $('#game-years-checkbox'),
                termsCheck = $('#game-terms-checkbox'),
				gameType = $('#game-type'),
				gameDomain = $('#game-domain'),
				gdgModuleId = false,
				gdgVoteVideoId = false,
				hasGameCityField = gameCity.length > 0,
				flagmMail = true,
				flagPhone = true;
	
		if( $('#gdg-module-id').length > 0) {
			gdgModuleId = $('#gdg-module-id');
		}
		if( $('#gdg-video-id').length > 0) {
			gdgVoteVideoId = $('#gdg-video-id');
		}
			
		if(gameType.val() == 'guessscore') {	
			if (gameEmail.val().length === 0) {				
				flagmMail = false;
			}
		}
		
		if (gamePhone.val().length === 0) {            
            flagPhone = false;
        }
		
		if(!flagmMail && !flagPhone){
			gameEmail.addClass('error-field');
			gameEmail.next().removeClass('g-hidden');
			gamePhone.addClass('error-field');
            gamePhone.parent().children('.validation-error').removeClass('g-hidden');
			flag = false;
		}		
		
		if(!flagPhone &&  gameType.val() == 'goaloftheday') {
			gamePhone.addClass('error-field');
            gamePhone.parent().children('.validation-error').removeClass('g-hidden');
		}
		
        if (gameName.val().length === 0) {
            gameName.addClass('error-field');
            gameName.parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
		
		if (gameSurname.val().length === 0) {
            gameSurname.addClass('error-field');
            gameSurname.parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
		
		if (hasGameCityField && (gameCity.html().length === 0 || gameCity.html() == '---' || gameCity.html() == 'Град')) {
            gameCity.parent().addClass('error-field');
            gameCity.parent().siblings('.validation-error').removeClass('g-hidden');
            flag = false;
        }
		
        		
        if (!(yearsCheck.is(':checked'))) {
            yearsCheck.parent().parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }
        if (!(termsCheck.is(':checked'))) {
            termsCheck.parent().parent().children('.validation-error').removeClass('g-hidden');
            flag = false;
        }


        var data = [];
		if(gameType.val() == 'guessscore') {
			$('.table-display').each(function (index) {
				var thisTeam1 = parseInt($(this).find('.prediction-team1 > span').html()),
					thisTeam2 = parseInt($(this).find('.prediction-team2 > span').html());
				if (!((isNaN(thisTeam1)) || (isNaN(thisTeam2)) || ($(this).hasClass("cant-vote")) || ($(this).hasClass("match-voted")))) {
					if(thisTeam1 === thisTeam2 && $('.non-equal-match').length !== 0) {
						$('#worldcup_game_signup .error-field-noprediction').text('Не може резултата да е равен!');
						$('#worldcup_game_signup .error-field-noprediction').removeClass('g-hidden');
						flag = false;
					}
					var currentData = {
						id: $(this).data('match-id'),
						scoreTeam1: thisTeam1,
						scoreTeam2: thisTeam2
					};
					data.push(currentData);
				}
			});

			if (data.length < 1) {
				$('#worldcup_game_signup .error-field-noprediction').text('Не сте избрали нито един резултат');
				$('#worldcup_game_signup .error-field-noprediction').removeClass('g-hidden');
				flag = false;
			} 
		}	
		
		if ((!$('.error-field-noprediction').hasClass('g-hidden')) )  {
			//console.log('ERRORRRRRRRRRRRRRRRRRRR');
			$('.profile-side-container').animate({
				scrollTop: 0
			}, 200);
		}
		
        if (flag) {
            $('#worldcup_game_signup .error-field-noprediction').addClass('g-hidden');
            var email = gameEmail.val(),
                    name = gameName.val(),
					surname = gameSurname.val(),
					city = hasGameCityField ? gameCity.html() : '',
                    years = yearsCheck.is(':checked'),
                    phone = gamePhone.val(),
                    terms = termsCheck.is(':checked'),
					game_type = gameType.val(),
					game_domain = gameDomain.val(),
					gdg_moduleId = false,
					gdg_voteVideoId = false;
					
			if(gdgModuleId.length > 0) {
				gdg_moduleId = gdgModuleId.val();
			}
			if(gdgVoteVideoId.length > 0) {
				gdg_voteVideoId = gdgVoteVideoId.val();
			}		
					
            gamePrediction(email, name, data, years, terms, phone, surname, city, game_type, game_domain, gdg_moduleId, gdg_voteVideoId);
        }
    });
    showVoteWorldCup();	
		
	$(".vq-interaction-module li input").on("click", function () {
		$('.alert-wrong-answer').addClass('hidden');
		$('.alert-correct-answer').addClass('hidden');
		var vqId = $(this).attr("name");
		var selectedAnswer = $(this).attr("value");
		var correctAnswer = $(this).data("crr");

		var data = {
			'vqId': vqId,
			'selectedAnswer': selectedAnswer,
			'correct': correctAnswer
		};

		if (correctAnswer == 1) {
			displayUserSidebarEuro("vq_game");
		} else if (correctAnswer == 0) {
			$('.alert-wrong-answer').removeClass('hidden');
		}
	});

	function displayUserSidebarEuro(a) {
		if ($("#bottom_header_forms").length == 0) {
			$("body").append("<div id='bottom_header_forms'></div>");
		}
		$("#bottom_header_forms").load("/euro/game_form/form_" + String(a), function () {

		});
		$("#" + a).removeClass("g-hidden");
		$("#" + a).removeClass("g-hidden-right-slide");
		document.getElementsByClassName("profile-overlay")[0].style.display = "block";
		document.getElementsByTagName("body")[0].style.overflow = "hidden";
	}
	
	function gameVqGame(email, name, surname, phone, questionId, years, terms) {
			$.ajax({
				type: "POST",
				url: '/euro/video-questions/save_user_vote_vq',
				crossDomain: true,
				dataType: "json",
				data: {
					userEmail: email,
					userName: name,
					userSurname: surname,
					userYears: years,
					userTerms: terms,
					userPhone: phone,
					questionId: questionId,
					gameDomainName: 'game_ourgame'
				},
				success: function (response) {
					var data = response;
					if (data['success'] == 1) {
						$('#vq_game').addClass('g-hidden-right-slide');
						$('.profile-overlay').css('display', 'none');
						$('body').css('overflow', 'auto');
						var url = window.location.href;//'/euro/video-question';
						var form = $('<form action="' + url + '" method="post">' +
								'<input type="hidden" name="user_vote_message" value="Успешно се регистрирахте за играта!" />' +
								'</form>');
						$('body').append(form);
						form.submit();
					} else {
						$('#vq_game .error-field-noprediction').text(data['msg']);
						$('#vq_game .error-field-noprediction').removeClass('g-hidden');
					}
				}
			});
		}
		
		$('body').on('click', '#game_submit_vq_game', function (e) {
			e.preventDefault();
			var flag = true,
					gameEmail = $('#game-email'),
					gameName = $('#game-name'),
					gameSurname = $('#game-surname'),
					gamePhone = $('#game-phone'),
					gameQuestionId = $('#vid_quest_id'),
					yearsCheck = $('#game-years-checkbox'),
					termsCheck = $('#game-terms-checkbox');


			gameEmail.removeClass('error-field');
			gameEmail.next().addClass('g-hidden');
			gameName.removeClass('error-field');
			gameName.next().addClass('g-hidden');
			gameSurname.removeClass('error-field');
			gameSurname.next().addClass('g-hidden');
			gamePhone.removeClass('error-field');
			gamePhone.next().addClass('g-hidden');
			yearsCheck.parent().parent().children('.validation-error').addClass('g-hidden');
			termsCheck.parent().parent().children('.validation-error').addClass('g-hidden');

			if (gameEmail.val().length === 0) {
				gameEmail.addClass('error-field');
				gameEmail.next().removeClass('g-hidden');
				flag = false;
			}

			if (flag == true) {
				if (!validateEmail(gameEmail.val())) {
					gameEmail.addClass('error-field');
					gameEmail.next().removeClass('g-hidden');
					flag = false;
				}
			}
			if (gameName.val().length === 0) {
				gameName.addClass('error-field');
				gameName.parent().children('.validation-error').removeClass('g-hidden');
				flag = false;
			}
			if (gameSurname.val().length === 0) {
				gameSurname.addClass('error-field');
				gameSurname.parent().children('.validation-error').removeClass('g-hidden');
				flag = false;
			}
			if (gamePhone.val().length === 0) {
				gamePhone.addClass('error-field');
				gamePhone.parent().children('.validation-error').removeClass('g-hidden');
				flag = false;
			}
			if (flag == true) {
				if (!validatePhoneBG(gamePhone.val())) {
					gamePhone.addClass('error-field');
					gamePhone.next().removeClass('g-hidden');
					flag = false;
				}
			}
			if (gameQuestionId.val().length === 0) {
				flag = false;
			}
			if (!(yearsCheck.is(':checked'))) {
				yearsCheck.parent().parent().children('.validation-error').removeClass('g-hidden');
				flag = false;
			}
			if (!(termsCheck.is(':checked'))) {
				termsCheck.parent().parent().children('.validation-error').removeClass('g-hidden');
				flag = false;
			}
			
			if (flag) {
				$('#not_worldcup_our_game .error-field-noprediction').addClass('g-hidden');
				var email = gameEmail.val(),
						name = gameName.val(),
						surname = gameSurname.val(),
						phone = gamePhone.val(),
						questionId = gameQuestionId.val(),
						years = yearsCheck.is(':checked'),
						terms = termsCheck.is(':checked');
				gameVqGame(email, name, surname, phone, questionId, years, terms);
			}
		});
	
	
});